<script setup>
import PresenceHome from "./PresenceHome.vue";
import { computed, onBeforeMount, ref } from "vue";
import { useAuthStore } from "@/app/stores/authStore";
const authStore = useAuthStore();
const email = ref("");
const getUserLogged = computed(() => {
  return authStore.getUserLogged;
})
onBeforeMount(() => {
  const user = getUserLogged.value;
  email.value = user.email;
})
</script>

<template>
  <presence-home :email="email" />
</template>
